import { Group } from '@models';
import { GroupStore } from '@stores/GroupStore';
import actionResponse, { ActionResponse } from '../../ActionResponse';
import { GroupView } from '@views/GroupView';
import { describeGroupSaveFailure, describeGroupSaveSuccess } from './GroupSaveMessage';

export class UpdateGroupAction {
  constructor(private readonly store: GroupStore = new GroupStore()) {}

  // On a save, result.saveResult is what the admin is shown, whether the save worked or not
  public async Execute(raw: GroupView, reason?: 'SAVE' | string): Promise<ActionResponse> {
    if (!reason || reason !== 'SAVE') {
      return actionResponse.Success('reason was not save, no action taken');
    }

    const response = await this.store.Update({
      ...raw,
      potAmount: 0,
      pledgeAmount: 0,
      leaderboard: {},
      sections: [],
      availableJailCards: [],
      goalProgress: {},
      accountabilityPartners: [],
    } as Group);
    if (response.status === 'SUCCESS' && response.statusCode < 400) {
      const saveResult = describeGroupSaveSuccess(raw.name, 'saved', response.result?.summary);
      return actionResponse.Success(saveResult.message, { saveResult });
    }
    const saveResult = describeGroupSaveFailure(raw.name, 'saved', response);
    return { ...actionResponse.Error(saveResult.message), result: { saveResult } };
  }
}
